import React from 'react';
import { useRecoilState } from 'recoil';
import { btnColor } from '../../GlobalState';
import { styled } from '@mui/material/styles';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { tooltipContents } from '../tooltip/Const';
import { Button } from '@mui/material';

type TProps = {
  params: any;
  showLinearProgress: boolean;
  updateOrCreateInvoiceDetails: (goPreview?: boolean) => void;
  setDocumentDeleteModal: (value: React.SetStateAction<boolean>) => void;
};

export const InvoiceFooter: React.FC<TProps> = ({
  params,
  showLinearProgress,
  updateOrCreateInvoiceDetails,
  setDocumentDeleteModal
}) => {
  const [buttonColor] = useRecoilState(btnColor);
  return (
    <div
      className='save-btn-container'
      style={{
        backgroundColor: '#FFFFFF',
        position: 'fixed',
        bottom: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: 20
      }}
    >
      <div>
        <CustomTooltip title={tooltipContents.preview} placement='top'>
          <Button
            style={{ marginRight: 15, backgroundColor: buttonColor }}
            variant='contained'
            color='primary'
            disabled={showLinearProgress}
            onClick={() => {
              updateOrCreateInvoiceDetails(true);
            }}
          >
            プレビュー
          </Button>
        </CustomTooltip>
        <Button
          style={{
            marginRight: params.id ? 15 : 30,
            backgroundColor: buttonColor
          }}
          variant='contained'
          color='primary'
          disabled={showLinearProgress}
          onClick={() => {
            updateOrCreateInvoiceDetails();
          }}
        >
          保存
        </Button>
        {params.id && (
          <Button
            style={{
              color: '#758283',
              backgroundColor: '#F5F5F5',
              marginRight: 30
            }}
            variant='contained'
            color='primary'
            onClick={() => {
              setDocumentDeleteModal(true);
            }}
          >
            削除
          </Button>
        )}
      </div>
    </div>
  );
};
